import { render, staticRenderFns } from "./dialog-add-team-member.vue?vue&type=template&id=4e60c3fa&scoped=true&"
import script from "./dialog-add-team-member.vue?vue&type=script&lang=js&"
export * from "./dialog-add-team-member.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e60c3fa",
  null
  
)

export default component.exports